export default __webpack_public_path__ + "static/mobileApp-659a92929fa276d7830a2425a8db2b81.svg";